import { FileSelect } from 'bukku/components/Files/FileSelect';
import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import FileActions from 'bukku/redux/File/actions';
import { UploadLightboxFileManagerContext } from '../context';

const {
    readFile,
} = FileActions;

export function UploadFileManager() {
    const { states, setStates, props } = useContext(UploadLightboxFileManagerContext);
    const {
        isFileSelectVisible,
    } = states;
    const {
        setIsFileSelectVisible,
        setUploading,
    } = setStates;

    const {
        // parent
        fileTypeFilter,
    } = props;

    const dispatch = useDispatch();
    const handleOk = selectedFile => {
        setUploading(true);
        dispatch(readFile(selectedFile.id));
    };

    const handleCancel = () => {
        setIsFileSelectVisible(false);
    };

    return (
        <FileSelect
            visible={isFileSelectVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            fileTypeFilter={fileTypeFilter}
            mode="single"
            initFiles={[]}
        />
    );
}
